var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-warpper",
      on: {
        mousedown: function($event) {
          return _vm.userInactivityCheckStart()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-body",
          class: [_vm.bodyClass, { scrolled: _vm.isScrolled }, _vm.brandKey],
          attrs: { id: "app-body" }
        },
        [
          _c("div", { staticClass: "header_background" }, [
            _c(
              "div",
              { staticClass: "header_holder" },
              [
                _c("header-part", {
                  style:
                    _vm.tabletAndAbove && _vm.mainColumnWidth > 0
                      ? { width: _vm.mainColumnWidth + "px" }
                      : {},
                  attrs: { id: "header-part" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "v-app",
            [
              _c(
                "v-content",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [_c("router-view")],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.mobileBigAndBelow ? _c("bottom-navigation") : _vm._e(),
              _vm._v(" "),
              _vm.gelocationState ? _c("geolocation-message") : _vm._e(),
              _vm._v(" "),
              _vm.messageState ? _c("message-dialog") : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("footer-part")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 